import { render, staticRenderFns } from "./systemtags.vue?vue&type=template&id=2cbfcf9f&scoped=true&lang=pug"
import script from "./systemtags.vue?vue&type=script&lang=js"
export * from "./systemtags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbfcf9f",
  null
  
)

/* custom blocks */
import block0 from "./systemtags.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports